import React from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * A reusable button component that combines Bootstrap Button with FontAwesome icon
 * @param {string} icon - FontAwesome icon to display
 * @param {string} variant - Bootstrap button variant (default: "link")
 * @param {function} onClick - Click handler function
 * @param {string} className - Additional CSS classes
 * @param {string} iconClassName - Additional CSS classes for the icon
 * @param {string} iconPosition - Position of icon relative to children ("left" or "right", default: "left")
 * @param {React.ReactNode} children - Button content (text, etc.)
 * @param {object} ...props - Other Button props
 */
export default function IconButton({
  icon,
  variant = "link",
  onClick,
  className = "",
  iconClassName = "",
  iconPosition = "left",
  children,
  ...props
}) {
  const iconElement = icon ? (
    <span
      className={children ? (iconPosition === "left" ? "me-2" : "ms-2") : ""}
    >
      <FontAwesomeIcon icon={icon} className={iconClassName} />
    </span>
  ) : null;

  return (
    <Button
      variant={variant}
      onClick={onClick}
      className={className}
      {...props}
    >
      {iconPosition === "left" && iconElement}
      {children}
      {iconPosition === "right" && iconElement}
    </Button>
  );
}
